import { render } from "./App.vue?vue&type=template&id=fc25b3d4&scoped=true"
const script = {}

import "./App.vue?vue&type=style&index=0&id=fc25b3d4&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc25b3d4"]])

export default __exports__